import styled from 'styled-components';

export const Wrap = styled.div`
  height: 100%;
  overflow-y: auto;
`;
export const CenterWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
